import React, { ReactNode } from "react";

interface Step {
  title: string;
  body?: string | ReactNode;
  media?: string;
}

interface StepListProps {
  steps: Step[];
  layout?: "vertical" | "horizontal";
}

export const StepList: React.FC<StepListProps> = ({
  steps,
  layout = "vertical",
}) => {
  return (
    <ol
      className={
        "steplist" + (layout === "horizontal" ? " steplist--horizontal" : "")
      }
    >
      {steps.map((s, i) => (
        <li key={i} className="steplist__item">
          <div className="steplist__num" />
          <div>
            <h4>{s.title}</h4>
            {s.body && <p>{s.body}</p>}
            {s.media && (
              <div className="step__media">
                <span>{s.media}</span>
              </div>
            )}
          </div>
        </li>
      ))}
    </ol>
  );
};
